import React from 'react';
import PropTypes from 'prop-types';

const Error = ({ width, fill }) => (
  <svg width={width} height={width} viewBox="0 0 100 100">
    <g fill="none" fillRule="evenodd">
      <g fill={fill} fillRule="nonzero">
        <g>
          <path d="M50 21.875c-15.507 0-28.125 12.618-28.125 28.125S34.493 78.125 50 78.125 78.125 65.507 78.125 50 65.507 21.875 50 21.875zm3.39 12.305l-1.632 21.093h-3.516L46.61 34.18h6.782zM50 65.82c-1.942 0-3.516-1.573-3.516-3.515 0-1.943 1.574-3.516 3.516-3.516s3.516 1.573 3.516 3.516c0 1.942-1.574 3.515-3.516 3.515z" transform="translate(-1200 -185) translate(1200 185)" />
        </g>
      </g>
    </g>
  </svg>
)

Error.defaultProps = {
  fill: 'currentColor',
  width: '24px'
};

Error.propTypes = {
  fill: PropTypes.string,
  width: PropTypes.string
};

export default Error;
